module.exports = "<div class=\"page-content psr\">\n\t<div class=\"card psa translate-center--xy hoverable w-100 w-80--m w-70--l w-50--xl\">\n\t\t<div class=\"p-2\" *ngIf=\"loading\">\n\t\t\t<app-loader></app-loader>\n\t\t</div>\n\t\t<div class=\"card-content text-center\" *ngIf=\"!loading\">\n\t\t\t<span class=\"card-title\">My data</span>\n\t\t\t<div class=\"personal-data\">\n\t\t\t\t<p class=\"fz-2\">\n\t\t\t\t\t{{name}} {{lastName}}\n\t\t\t\t</p>\n\t\t\t</div>\n\t\t</div>\n\t</div>\n</div>"


//////////////////
// WEBPACK FOOTER
// F:/Projects/anoki/src/app/pages/profile/profile.component.html
// module id = ../../../../../src/app/pages/profile/profile.component.html
// module chunks = main